import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Tabs, Text } from 'src/packages/core';
import { DarkTheme, LightTheme, ThemeType, useTheme } from 'src/packages/theme';
import { Announcement, HeaderNotifications } from 'src/packages/common';

import { Announcements } from './Announcements';
import { Notifications } from './Notifications';
import { NotificationPopoverContentWrapper } from '../../Header.styles';

interface NotificationIconPopoverContentProps {
  theme: ThemeType;
  announcements: Announcement[];
  notifications?: HeaderNotifications;
}

export const NotificationIconPopoverContent = ({
  theme,
  announcements,
  notifications,
}: NotificationIconPopoverContentProps) => {
  const { t } = useTranslation();

  const contextTheme = useTheme();

  const defaultTheme = useMemo(() => {
    return theme
      ? theme === 'light'
        ? { ...LightTheme, rtl: contextTheme.rtl }
        : { ...DarkTheme, rtl: contextTheme.rtl }
      : contextTheme;
  }, [contextTheme, theme]);

  return (
    <NotificationPopoverContentWrapper>
      <Flex
        width={'100%'}
        flexDirection={'column'}
        py={'10px'}
        backgroundColor={defaultTheme.colors.background.secondary.BG3}
      >
        {notifications ? (
          <Tabs
            tabsList={[
              <Text
                variant={'p2'}
                text={`${t('header.menu.notification_icon.tab.notifications')}${
                  notifications.unread > 0 ? ` (${notifications.unread})` : ''
                }`}
                color={
                  theme === 'light' ? LightTheme.colors.text.primary : DarkTheme.colors.text.primary
                }
                key={'notifications'}
              />,
              <Text
                variant={'p2'}
                text={t('header.menu.notification_icon.tab.announcements')}
                color={
                  theme === 'light' ? LightTheme.colors.text.primary : DarkTheme.colors.text.primary
                }
                key={'announcements'}
              />,
            ]}
            tabsChildern={[
              <Notifications notifications={notifications} theme={theme} key={'notifications'} />,
              <Announcements announcements={announcements} theme={theme} key={'announcements'} />,
            ]}
          />
        ) : (
          <Announcements announcements={announcements} theme={theme} key={'announcements'} />
        )}
      </Flex>
    </NotificationPopoverContentWrapper>
  );
};
